import { CheckOutlined, CloseOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Button, Spin, Table } from 'antd';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

const ReviewTab: React.FC<any> = ({ isViewingPdfPmOffer }) => {
  const pmOffer = useSelector((state: RootState) => state?.models?.pmOffer);

  const [numPages, setNumPages] = useState<number | null>(null);
  const [scale, setScale] = useState(1.5);

  //const isLastStatusSelected = pmOffer.enumPmOfferStatus?.name === PmOfferProjectStatus.Lucrare_facturata;

  const columns = [
    {
      title: 'Validation Status',
      dataIndex: 'content',
      key: 'content',
    },
  ];

  const dataSource = [
    {
      key: '1',
      content: (
        <>
          {pmOffer.companyId ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Client
        </>
      ),
    },
    {
      key: '2',
      content: (
        <>
          {pmOffer.accountSaleId ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Agent de vanzari
        </>
      ),
    },
    {
      key: '3',
      content: (
        <>
          {pmOffer.enumPmOfferStatusId ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Status
        </>
      ),
    },
    {
      key: '4',
      content: (
        <>
          {pmOffer.enumPmOfferContractTypeId ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Tip oferta
        </>
      ),
    },
    {
      key: '5',
      content: (
        <>
          {pmOffer.date ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Data Oferta
        </>
      ),
    },
    {
      key: '8',
      content: (
        <>
          {pmOffer.pmOfferIntervals?.length > 0 ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Intervale de plata
        </>
      ),
    },
    {
      key: '9',
      content: (
        <>
          {pmOffer.pmOfferWorkPlaceItems?.length > 0 ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Dispozitive
        </>
      ),
    },
    {
      key: '10',
      content: (
        <>
          {pmOffer.pmOfferLaborExtras?.length > 0 ? (
            <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
          ) : (
            <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
          )}
          Manopera extra
        </>
      ),
    },
  ];

  // Add project dates if the last status is selected
  // if (isLastStatusSelected) {
  //   dataSource.push(
  //     {
  //       key: '6',
  //       content: (
  //         <>
  //           {pmOffer.dateStart ? (
  //             <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
  //           ) : (
  //             <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
  //           )}
  //           Data Incepere Proiect
  //         </>
  //       ),
  //     },
  //     {
  //       key: '7',
  //       content: (
  //         <>
  //           {pmOffer.dateEnd ? (
  //             <CheckOutlined style={{ color: 'green', marginRight: 8 }} />
  //           ) : (
  //             <CloseOutlined style={{ color: 'red', marginRight: 8 }} />
  //           )}
  //           Data Finalizare Proiect
  //         </>
  //       ),
  //     }
  //   );
  // }

  if (isViewingPdfPmOffer) {
    return <Spin size='large' style={{ position: 'fixed', left: '50%', top: '50%' }} />;
  }
  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.2, 3.0));
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.5));
  };

  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        showHeader={false}
        size='small'
        style={{ border: 'none', background: 'none' }}
        rowClassName={() => 'minimalist-row'}
      />

      <div>
        {pmOffer.equipmentTab.pdfUrl != undefined ? (
          <div className='pdf-div'>
            <div className='pdf-content'>
              <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
                <Button icon={<ZoomOutOutlined />} onClick={handleZoomOut} />
                <Button icon={<ZoomInOutlined />} onClick={handleZoomIn} />
              </div>

              <Document
                file={pmOffer.equipmentTab.pdfUrl}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                onLoadError={(error) => console.error('Error loading PDF:', error)}
              >
                {numPages !== null &&
                  Array.from({ length: numPages }, (_, index) => (
                    <div key={`page_${index + 1}`} className='pdf-page'>
                      <Page
                        pageNumber={index + 1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        scale={scale}
                      />
                    </div>
                  ))}
              </Document>
            </div>
          </div>
        ) : (
          <Spin size='large' className='spinner' />
        )}
      </div>
    </div>
  );
};

export default ReviewTab;
